import apiClient from "../api/client";
import { User } from "../types/types";
import { UserDropdownDto } from "../types/userypes";

export const getUsers = () =>
  apiClient.get<User[]>("/api/User");

export const getUser = (userGuid: string) =>
  apiClient.get<User>(`/api/User/${userGuid}`);

export const toggleUser = (userGuid: string) =>
  apiClient.put(`/api/User/Toggle/${userGuid}`);

export const assignUserRoles = (
  userGuid: string,
  roleGuids: string[]
) =>
  apiClient.post(
    `/api/User/AssignRoles/${userGuid}`,
    { roleGuids }
  );

export const getDropdownUsers = () =>
  apiClient.get<UserDropdownDto[]>(
    "/api/User/GetDropdownUsers"
  );  

  export const syncOktaUserAndGetGuid = async (data: {
    sub: string;
    firstName: string;
    lastName: string;
    email?: string;
  }): Promise<string> => {
    // Step 1: Ensure user exists
    await apiClient.post(
      "/api/User/CreateUserIfNotExistsOkta",
      data
    );
  
    const res = await apiClient.get<string>(
      "/api/User/GetUserGuidByExternalIdentity",
      {
        params: {
          identityProvider: "OKTA",
          externalUserId: data.sub,
        },
      }
    );
  
    return res.data;
  };
  
export const createUserIfNotExists = async (payload: {
  guid: string;
  firstName: string;
  lastName: string;
  email: string;
}) => {
  return apiClient.post("/api/User/CreateUserIfNotExists", payload);
};
